import React, { useState, useEffect } from "react";
import "./ProductsCategory.css";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import { useLocation, useNavigate } from "react-router-dom";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import ShopCard from "../../../Components/ShopCard/ShopCard";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import { useBaseUrl } from "../../../ApiContext";

export default function ProductsCategory() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const navigate = useNavigate();
  const location = useLocation();
  const { categorySlug } = location.state || {};
  const [mainSlug, setMainSlug] = useState(categorySlug);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [categories, setCategories] = useState([]);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleCategoryClick = (category) => {
    if (category.has_child) {
      setMainSlug(category.slug);
    } else {
      navigate("/partialProducts", { state: { categorySlug: category.slug } });
    }
  };
  
  
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/category/${mainSlug}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
          );
          setCategories(response.data.categories);
        } catch (error) {
        console.log("Error during getting product's categories", error);
      }
    };
    if (userToken) {
      fetchCategories();
    }
  }, [baseUrl, userToken, mainSlug]);

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <h3 className="pageTitle partialProductsHeading">
            دسته بندی محصولات
          </h3>
          <div className="productsCategoryContent scroll centeredFlex">
            {categories.length > 0 &&
              categories.map((category) => (
                <ShopCard
                  key={category.id}
                  label="category"
                  {...category}
                  onShopCardClick={() => handleCategoryClick(category)}
                />
              ))}
          </div>
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
